<script>
export default {
  name: 'Header',
  props: {
    klass: String,
    user: {
      type: Object,
      default: function () {
        return {}
      }
    },
    homePage: {
      type: String,
      default: null,
    }
  },
  methods: {
    backtoHomePage() {
      if(this.homePage) {
        window.location = this.homePage
        return
      }
      this.$router.push('/shop')
    }
  }
}
</script>
<template>
  <div :class="['header', 'shadowed', 'padding-x', klass]">
    <div class="max-1200 flex-box">
      <div class="logo" @click="backtoHomePage"></div>

        <div class="btn btn-login-success" v-if="user && user.first_name">
          <a href="/" target="_blank">
            <div class="account-initials">
              {{user.full_name.split(" ").map(name => name[0]).join("").toUpperCase()}}
            </div>
          </a>
        </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.header {
  .flex-box {
    align-items: center;
  }

  .btn-login-success {
    box-shadow: none;
    height: 40px;
    right: calc(50vw - calc(min(600px, 50vw)) + 24px);
    top: unset;
  }
}
</style>
